export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14870.22b20904.jpg";